/**
 * Small UTC date helpers shared by every surface that buckets activity by
 * calendar day. Keeping a single definition here stops the producer (cost
 * records) and the consumer (profile runs heatmap) from drifting onto
 * different day-key conventions.
 */

/** Milliseconds in one calendar day. */
export const UTC_DAY_MS = 86_400_000;

/**
 * Convert an epoch-ms timestamp to its UTC `YYYY-MM-DD` day key. This is the
 * canonical key shape for per-day maps (`agentRunStartsByDay`, contribution
 * heatmap cells) so they align without timezone skew.
 */
export function utcDayKey(epochMs: number): string {
  return new Date(epochMs).toISOString().slice(0, 10);
}
